<template>
	<div class="container audit-card mx-auto">
		<div class="row">
			<div class="audit-card--score col-2 col-md-12 col-lg-2 my-auto text-left pr-0">
				<div class="w-100 mx-auto text-center text-primary">
					<h4 class="mb-0 pb-0">{{date.day}}</h4>
				</div>
				<div class="w-100 mx-auto text-center ">{{date.month.substring(0, 3)}}</div>
			</div>
			<div class="col-7 col-md-12 col-lg-7 my-auto text-left ">
				<span class="w-100 font-weight-bold">{{venue_name}}</span>
				<div class="w-100 audit-card--who-when">
					<i>Scheduled by</i>
					<span>{{user.first_name + ' ' + user.last_name}}</span>
				</div>
			</div>
			<div class="col-3 col-md-12 col-lg-3 my-auto text-right text-md-left text-lg-right pl-0">
				<a :href="schedule_url" class="btn btn-primary">Edit</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:[
			'date',
			'user',
			'venue_name',
			'schedule_url'
		],
	}
</script>
